import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, tap, of, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginModel } from '../model/login.model';
import { LocalStorageService } from '../services/localstorage.service';
import { SnackBarService } from '../services/snack-bar-service.service';
import { IConsultaSubFrotaModel } from '../subFrota/model/subFrota.model';
import { IBuscaVeiculoModel, IConsultaVeiculoModel, IFiltroVeiculoModel } from './model/veiculo.model';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Injectable({
  providedIn: 'root'
})
export class VeiculoService {
  
  public usuario!: LoginModel;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient, 
      private localStorageService: LocalStorageService,
      private snackBar: SnackBarService) { 
    var userData = this.localStorageService.getItem('userData');

    if (userData != null) {
      this.usuario = JSON.parse(userData);
    }
  }

  
  listVeiculo(filtro: IFiltroVeiculoModel): Observable<IConsultaVeiculoModel>{

    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ListaVeiculo;

    return this.http.post<IConsultaVeiculoModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar os veículos.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IConsultaVeiculoModel>('Não foi possível consultar os veículos.', {sucesso : false, retorno: [], mensagens: []}))
    );
  }

  searchVeiculo(filtro: IBuscaVeiculoModel): Observable<IConsultaVeiculoModel>{

    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_BuscaVeiculo;

    return this.http.post<IConsultaVeiculoModel>(url, filtro, this.httpOptions).pipe(map(response => {
      response.retorno.forEach( (veiculo) => {
        veiculo.busca = veiculo.codigo.toString().padStart(6,'0') + ' - ' + veiculo.placa.trim() + ' - ' + veiculo.modelo.trim() + ' - ' + veiculo.numeroFrota.trim();
      });
      return response;
    }));
  }

  private handleError<T>(mensagem = 'Não foi possível realizar a operação.', result?: T) {
    return (error: any): Observable<T> => {

      this.snackBar.flashMessage(mensagem, ['snackbar-error'], 'Fechar', 0);

      return of(result as T);
    };
  }

}
